<script>
    export let skill;
</script>

{#if skill.type == 2 || skill.proficiency == 2}
    <div id="container">
        {skill.title}
        <div class="spacer"/>
        <div class="yellow"/>
        <div class="yellow"/>
    </div>
{:else if skill.type == 3  || skill.proficiency == 3}
    <div id="container">
        {skill.title}
        <div class="spacer"/>
        <div class="green"/>
        <div class="green"/>
        <div class="green"/>
    </div>
{:else if skill.type == 1 || skill.proficiency == 1}
    <div id="container">
        {skill.title}
        <div class="spacer"/>
        <div class="red"/>
    </div>
{:else}
    <div id="container">
        {skill.title}
        <div class="spacer"/>
        <div class="purple"/>
        <div class="purple"/>
        <div class="purple"/>
        <div class="purple"/>
    </div>
{/if}

<style>
    #container {
        border: none;
        padding: 8px 16px;
        color: rgba(0, 60, 30, 0.8);
        background-color: rgba(255, 255, 255, 1);
        font-weight: bold;
        border-radius: 8px;
        border-radius: 8px;
        margin-right: 8px;
        margin-top: 8px;
        font-size: 12px;
        line-height: 12px;
        display: flex;
        flex-direction: row;
    }

    .red {
        background-color: rgba(200, 100, 100, 0.8);
    }

    .yellow, .green, .red, .purple {
        width: 6px;
        height: 13px;
        margin-left: 2px;
        border-radius: 12px;
    }

    .yellow {
        background-color: rgba(231, 231, 36, 0.8);
    }

    .green {
        background-color: rgba(100, 231, 36, 0.8);
    }

    .purple {
        background-color: rgba(30, 131, 255, 0.8);
    }

    .spacer {
        width: 8px;
    }

</style>